import React from 'react';
import { Section, Content, Main } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';

import AddressFind from './../address'

class Test extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  render() {

    return (
      <Section>

        <ToolbarPrimary title="Tests"/>
        <BreadcrumbItem to='/tests'>Tests</BreadcrumbItem>

        <Content>
          <Main>

            <Ttolbar title="Tests"/>

            <AddressFind/>

          </Main>
        </Content>
      </Section>
    )
  }
}


export default Test;
